import { render, staticRenderFns } from "./ModalAge.vue?vue&type=template&id=6ff5f2eb&scoped=true&"
import script from "./ModalAge.vue?vue&type=script&lang=js&"
export * from "./ModalAge.vue?vue&type=script&lang=js&"
import style0 from "./ModalAge.vue?vue&type=style&index=0&id=6ff5f2eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff5f2eb",
  null
  
)

export default component.exports